const formatDate = (dateString, locale = "en-NZ", timeZone) => {
  const date = new Date(dateString);
  return date.toLocaleDateString(locale, {
    timeZone: timeZone,
    year: "numeric",
    month: "long",
    day: "2-digit",
  });
};

const getLocalDateAndTime = () => {
  let tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
  let localISODate = new Date(Date.now() - tzoffset).toISOString().slice(0, -1);

  return localISODate;
};

const limitText = (text, limit) =>
  text.length > limit ? `${text.slice(0, limit)}...` : text;

const isEqual = (from, to) => from === to;

const isEmpty = (value) =>
  value === "" || value === null || value === undefined;

const formatGender = (genderId) => {
  if (genderId === 1) return "Male";
  else if (genderId === 2) return "Female";
  else if (genderId === 3) return "Other";
  else return "Unknown";
};

const validateEmail = (email) => {
  const regex = /^\S+@\S+\.\S+$/;
  return regex.test(email);
};

const getBrowserName = (userAgent) => {
  if (userAgent.includes("Edg")) {
    return "Microsoft Edge";
  } else if (userAgent.includes("OPR") || userAgent.includes("Opera")) {
    return "Opera";
  } else if (userAgent.includes("Chrome")) {
    return "Chrome";
  } else if (userAgent.includes("Safari")) {
    return "Safari";
  } else if (userAgent.includes("Firefox")) {
    return "Firefox";
  } else if (userAgent.includes("MSIE") || userAgent.includes("Trident")) {
    return "Internet Explorer";
  } else {
    return "unknown";
  }
};

const clearLocalStorageItems = () => {
  const items = [
    "LS_CHECKED_ITEMS",
    "LS_CONGRATS",
    "LS_CUSTOMER_ID",
    "LS_DETAILS",
    "LS_IS_ORDER_SAVED",
    "LS_ORDER_ID",
    "LS_ORDER_LINE",
    "LS_ORGANISATIONS_LIST",
    "LS_PAYMENT_TYPE",
    "LS_PRICE_GST_INCLUDED",
    "LS_PRICE_PAYABLE",
    "LS_PRICE_PLAN_PRICE",
  ];
  items.forEach((storeKey) => {
    if (localStorage.getItem(storeKey) !== null) {
      localStorage.removeItem(storeKey);
    }
    if (sessionStorage.getItem(storeKey) !== null) {
      sessionStorage.removeItem(storeKey);
    }
  });
};

module.exports = {
  formatDate,
  getLocalDateAndTime,
  limitText,
  isEqual,
  isEmpty,
  formatGender,
  validateEmail,
  getBrowserName,
  clearLocalStorageItems,
};
